import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TipService {
  constructor() {}

  public saveTip(name: string) {
    localStorage.setItem(name, 'true');
  }

  public checkTip(name: string) {
    if (!name) {
      return false;
    }

    return !!localStorage.getItem(name);
  }
}
